import { SvgIcon } from '@mui/material';
import { FC } from 'react';

interface EditIconProps {
  size?: number;  
}

const EditIcon: FC<EditIconProps> = ({ size = 18 }) => (
  <SvgIcon sx={{ width: size, height: size }}>
    <path d="M13.875 1.87419C14.1734 1.57582 14.578 1.4082 15 1.4082C15.422 1.4082 15.8266 1.57582 16.125 1.87419C16.4234 2.17256 16.591 2.57724 16.591 2.99919C16.591 3.42115 16.4234 3.82582 16.125 4.12419L9 11.2492L6 11.9992L6.75 8.99919L13.875 1.87419Z" fill="#702DFF" />
    <rect x="1.125" y="13.5" width="15.75" height="2.25" fill="#702DFF" />
  </SvgIcon>
 );

export default EditIcon;